export default __webpack_public_path__ + "static/media/users-clients-inactive.4689f024.svg";